module.exports = __webpack_public_path__ + "src/asset/svg/bookmark/v/artist.svg?5fa72602a26b07f7acae7ea39c1374ec";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/bookmark/v/artist.svg
// module id = 6
// module chunks = 0